// AuthCallback — placeholder for OAuth / magic-link return.
// Supabase JS auto-handles the URL hash on getCurrentUser, so
// we just wait for the auth context to update and then redirect.

import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAuth } from '../auth/AuthContext'
import { buildLoginHref, sanitizeAuthNext, peekStashedAuthNext, clearStashedAuthNext } from '../auth/redirect'

export default function AuthCallback() {
  const { user, loading } = useAuth()
  const navigate = useNavigate()
  const [params] = useSearchParams()

  // Recover the destination once. The ?next= query param (from the OAuth
  // redirectTo) takes priority; if the provider dropped it, fall back to the
  // sessionStorage stash written before login. peek is side-effect-free, so
  // this initializer is safe under React strict-mode double-invocation.
  const [next] = useState(() => sanitizeAuthNext(params.get('next') ?? peekStashedAuthNext()))

  useEffect(() => {
    if (loading) return
    // The stash has served its purpose — clear it so it can't leak into a
    // later navigation.
    clearStashedAuthNext()
    navigate(user ? next : buildLoginHref(next), { replace: true })
  }, [user, loading, navigate, next])

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'var(--olv-text-tertiary)',
        fontFamily: 'var(--font-mono)',
        fontSize: 11,
        letterSpacing: '0.10em',
      }}
    >
      RESOLVING SESSION…
    </div>
  )
}
